// Load a new script
// --------------------------------------------------

function loadScript(src) {
	return new Promise((resolve) => {
		const script = document.createElement('script');

		script.src = src;
		script.onload = () => resolve(true);
		script.onerror = () => console.log('Failed to load script: ' + src);

		document.querySelector('body').appendChild(script);
	});
}